// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"1":"3979aadf","28":"3979aadf","49":"56d8d458","52":"999718ac","118":"3979aadf","736":"c18e1c12","779":"3979aadf","780":"3979aadf","820":"9995d2f5","871":"3979aadf"}[chunkId] + ".css";
};